// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__KRxgj"};